import { useMemo, useState, useEffect } from "react";
import { FLUXOS_DOCUMENTOS } from "./fluxosDocumentos";

const STATUS_CONCLUIDO = "Concluído";
const STATUS_ISENTA = "Empresa isenta";
const STATUS_CONFLITO = "Conflito: IE no Banco";
const STATUS_PENDENTE = "Pendente";

function normalizarNomeArquivo(caminho) {
  const nomeComExtensao = caminho.split(/[\\/]/).pop().trim();
  return nomeComExtensao.split(".").slice(0, -1).join(".").toLowerCase();
}

/**
 * Deriva o status de cada arquivo obrigatório do fluxo a partir dos
 * documentos já enviados (objDocs) e dos dados da empresa/OS.
 *
 * Regra especial de "Inscricao-estadual":
 * - se a IE estiver marcada como "ISENTA" no cadastro, a etapa é sempre
 *   dispensada, independente de forcarExigenciaIE (checado primeiro, pois
 *   "ISENTA" é uma string truthy e cairia no caso de conflito abaixo);
 * - se a empresa já tem IE cadastrada no banco (e não é "ISENTA") e o
 *   usuário não forçou a exigência, é conflito;
 * - se não tem IE e não foi forçado, a etapa é dispensada (isenta).
 */
export function useEtapasDocumentos({ fluxo, dados, objDocs, forcarExigenciaIE }) {
  const config = FLUXOS_DOCUMENTOS[fluxo];

  const arquivosEsperados = useMemo(
    () => config.getArquivosBase(dados).map((nome, id) => ({ id, nome })),
    [config, dados.tipo?.id]
  );

  const [arquivosEtapas, setArquivosEtapas] = useState([]);

  useEffect(() => {
    const documentosNormalizados = (objDocs || []).map(normalizarNomeArquivo);

    const etapas = arquivosEsperados.map((arquivo) => {
      const nomeNormalizado = arquivo.nome.toLowerCase();
      const jaTemArquivo = documentosNormalizados.includes(nomeNormalizado);

      if (jaTemArquivo) return { ...arquivo, status: STATUS_CONCLUIDO, cor: "#07bc0c" };

      if (nomeNormalizado === "inscricao-estadual") {
        if (dados?.empresa?.ie === "ISENTO") {
          return {
            ...arquivo,
            status: STATUS_ISENTA,
            cor: "#faad14",
            detalhe: "Etapa dispensada pelo sistema.",
          };
        }

        if (dados?.empresa?.ie && !forcarExigenciaIE) {
          return {
            ...arquivo,
            status: STATUS_CONFLITO,
            cor: "#ff4d4f",
            detalhe: "Remova a IE no cadastro para confirmar isenção.",
          };
        }

        if (!dados?.empresa?.ie && !forcarExigenciaIE) {
          return {
            ...arquivo,
            status: STATUS_ISENTA,
            cor: "#faad14",
            detalhe: "Etapa dispensada pelo sistema.",
          };
        }
      }

      return { ...arquivo, status: STATUS_PENDENTE, cor: "gray" };
    });

    setArquivosEtapas(etapas);
  }, [objDocs, dados, forcarExigenciaIE, arquivosEsperados]);

  const pendenteIndex = useMemo(
    () =>
      arquivosEtapas.findIndex(
        (etapa) => etapa.status !== STATUS_CONCLUIDO && etapa.status !== STATUS_ISENTA && etapa.status !== STATUS_CONFLITO
      ),
    [arquivosEtapas]
  );

  const proximaEtapaPendente = arquivosEtapas.find((etapa) => etapa.status === STATUS_PENDENTE);

  return { arquivosEtapas, pendenteIndex, proximaEtapaPendente, regrasRemocao: config.regrasRemocao, titulo: config.titulo };
}